import { Trans } from 'react-i18next';

import useTranslate from '@/hooks/useTranslate';
import BlockQuote from '@/ui/members/components/BlockQuote';
import Card from '@/ui/members/components/Card';
import Heading from '@/ui/members/components/typography/Heading/Heading';
import UL from '@/ui/members/components/typography/UL';

const GetAccessTo = () => {
  const translateKeyPath = 'pages.members.pages.Onboarding.components.shared.GetAccessTo';
  const { t } = useTranslate(translateKeyPath);

  return (
    <>
      <div className="mb-6 text-center">
        <Card gradientBottom>
          <Heading className="font-medium mt-4" value={3} text={t('featuresAvailableForFree')} />

          <UL
            className="flex flex-col items-center mb-4"
            listStyle="greenCheckmarks"
            listItems={[
              t('inAppChallenges'),
              t('motivatingMissions'),
              <Trans
                key="trans1"
                i18nKey={`${translateKeyPath}.dailyInsights`}
                components={[<br key="br1" />]}
              />
            ]}
          />

          <img
            className="mb-4"
            src="/images/onboarding/Challenges-and-Trends-2up.png"
            alt={t('screenOfInAppChallenges')}
          />
        </Card>
      </div>

      <BlockQuote
        quote={t('iFeelStronger')}
        name={t('affectMember')}
        title={t('helpthatStaysWithYou')}
      />
    </>
  );
};

export default GetAccessTo;
